import { AfterViewInit, Component, computed, ElementRef, inject, OnInit, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
	CommonButtonRowWidget,
	CommonSelectFieldWidget,
	CommonTextFieldWidget
} from '@eforall/common';
import { DashboardDialogFramePart, DialogContext } from '@eforall/dashboard';
import { AccGoalFormValues, DialogMode } from '@interfaces';
import { GoalEditorDialogData } from '../goal-dialog-data';
import { GoalEditorDialogDataService } from './goal-editor-dialog-data.service';
import { GoalEditorForm } from './goal-editor.form';


@Component({
	selector: 'goal-editor-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		CommonTextFieldWidget,
		CommonSelectFieldWidget,
		CommonButtonRowWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './goal-editor.dialog.html'
})

export class GoalEditorDialog implements OnInit, AfterViewInit {

	public dialogRef = inject(MatDialogRef<GoalEditorDialog>);
	private dialogContext: DialogContext<GoalEditorDialogData> = inject(MAT_DIALOG_DATA);
	private dialogDataService = inject(GoalEditorDialogDataService);

	public readonly form = new GoalEditorForm();
	public goalEditorBtn = viewChild.required<ElementRef<HTMLButtonElement>>('goalEditorBtn');

	public readonly addOrEditTitle = computed(() => {
		return this.dialogContext.data?.mode == DialogMode.ADD ? 'Add Goal' : 'Edit Goal';
	});

	public readonly buttonText = computed(() => {
		return this.dialogContext.data?.mode == DialogMode.ADD ? 'Add' : 'Save';
	});

	async ngOnInit() {
		const data = this.dialogContext.data;
		if (data) {
			this.form.setDialogData(data);
			if (data.mode === DialogMode.EDIT) {
				await this.dialogDataService.getGoalFormValues(data.accGoalId);
			}
		}
	}

	ngAfterViewInit() {
		this.form.form.setSubmitButton(this.goalEditorBtn(), async (values: AccGoalFormValues, changed: string[]) => {
			await this.saveOrAddGoal(values);
		});
	}

	async saveOrAddGoal(values: AccGoalFormValues) {
		const data = this.dialogContext.data;
		if (data) {
			if (data.mode == DialogMode.ADD) {
				await this.dialogDataService.addGoal(values);
			} else {
				await this.dialogDataService.editGoal(data.accGoalId, values);
			}
			this.dialogRef.close();
		}
	}

	revertChanges() {
		this.form.form.resetAll();
	}
}